import * as React from 'react';
import DetailsCard from '../common/DetailsCard';
import { replaceTokens } from '../../StringUtils';
import strings from './strings';
import './style/index.scss';
export class PerformanceRatingCard extends React.PureComponent {
    static isValidData(performanceRating) {
        return !!performanceRating;
    }
    render() {
        const { performanceRating, firstName } = this.props;
        if (!PerformanceRatingCard.isValidData(performanceRating)) {
            return null;
        }
        const subject = firstName || strings.thisEmployee;
        return (React.createElement(DetailsCard, { className: "performance-rating-card", title: strings.cardTitle },
            React.createElement("div", { className: "performance-rating-card__rating" }, performanceRating),
            React.createElement("div", { className: "performance-rating-card__description" },
                React.createElement("span", { className: "sensitive-info" }, replaceTokens(strings.descriptionPrefix, subject)),
                React.createElement("span", { className: "performance-rating-card__rating-desc" }, ` ${performanceRating} `),
                React.createElement("span", null, strings.descriptionSuffix))));
    }
}
export default PerformanceRatingCard;
